import Styled,{css } from 'styled-components'

export const Container = Styled.div`
  color: var(--primary-color) !important;
  
  .custom-search {
    input {
      color: var(--primary-color) !important;
      margin-bottom: 5px;
      font-family: var(--font-family);
    }
    
    label {
      color: var(--primary-color) !important;
      font-size: 1.1rem !important;
      font-family: var(--font-family);
    }
    
    label.Mui-focused {
      color: var(--primary-color) !important;
    }
    
    .MuiInput-underline:before {
      border-bottom-color: var(--primary-color) !important;
    }
    
    .MuiInput-underline:hover:not(.Mui-disabled):before {
      border-bottom-color: var(--primary-color) !important;
    }
    
    .MuiInput-underline:after {
      border-bottom-color: var(--primary-color) !important;
    }
  }
  
  .input-group-wl {
    color: var(--primary-color) !important;
    
    svg {
      color: var(--primary-color) !important;
    }
  }
`